// import components and types
import {
  styled,
  Box,
  TableCell,
  TableRow,
  Table,
  TableProps,
  TableCellProps,
  TableRowProps,
  BoxProps,
  Typography
} from '@mui/material';

// import styles
import { IconContainer } from 'components/mrp/mrp.styles';

export const StyledSummaryCardTableCellBox = styled(Box)<BoxProps>(() => ({
  height: '100%',
  display: 'flex'
}));

export const StyledSummaryCardTable = styled(Table)<TableProps>(() => ({
  'tr:last-child td': { border: 0 },
  th: { fontFamily: 'SourceSansPro-Regular' },
  'tr td:first-of-type': { fontFamily: 'SourceSansPro-Bold' }
}));

export const StyledSummaryCardTableCell = styled(TableCell)<TableCellProps>(
  () => ({
    border: 'none'
  })
);

export const StyledSummaryCardListTableCell = styled(
  StyledSummaryCardTableCell
)(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '25vh',
  overflowY: 'auto'
}));

export const StyledSummaryCardTableRow = styled(TableRow)<TableRowProps>(
  ({ theme }) => ({
    verticalAlign: 'top',
    borderBottom: '1px solid ' + theme.palette.divider,

    '&:last-child': {
      borderBottom: 'none'
    }
  })
);

export const StyledSummaryCardIconContainer = styled(IconContainer)(
  ({ theme }) => ({
    marginRight: theme.spacing(4)
  })
);

export const StyledLinkIcon = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  marginLeft: theme.spacing(0.5),
  cursor: 'pointer',
  '& svg': {
    fontSize: theme.typography.pxToRem(12)
  }
}));

export const StyledSummaryCardLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 12,
  textTransform: 'lowercase',
  '&:first-letter': {
    textTransform: 'uppercase'
  },
  borderBottom: `1px dashed ${theme.vars.palette.outline.variant}`
}));

// A care receiver and the treatment derived for them, stacked tight. Deliberately not
// StyledBoxFlexColumnSmallGap, whose "small" gap is theme.spacing(2) and pushes the treatment a
// full line away from the patient it belongs to.
export const StyledSummaryCardClient = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

// The treatment as a quiet subtitle under its care receiver, matching the appointment form.
// Deliberately not StyledSummaryCardLabel: that is the bold, lowercased, dash-underlined style used
// for the synchronisation destinations, which reads as a heading rather than as context.
export const StyledSummaryCardTreatment = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.vars.palette.text.secondary
}));
